import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">{t('admin.dashboard')}</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-900 mb-4">{t('admin.quickActions')}</h2>
            <div className="space-y-2">
              <Link to="/admin/users" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.manageUsersKyc')}
              </Link>
              <Link to="/admin/candidates" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.manageCandidates')}
              </Link>
              <Link to="/admin/donations" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.viewDonations')}
              </Link>
              <Link to="/admin/vouchers" className="block px-4 py-2 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition border border-green-200 font-medium">
                ✅ Manage Pending Vouchers
              </Link>
              <Link to="/admin/admins" className="block px-4 py-2 bg-primary-50 text-primary-700 rounded-lg hover:bg-primary-100 transition">
                {t('admin.manageAdmins')}
              </Link>
              <Link to="/admin/documents" className="block px-4 py-2 bg-indigo-50 text-indigo-700 rounded-lg hover:bg-indigo-100 transition">
                📂 Upload RAG Documents
              </Link>
              <Link to="/admin/faqs" className="block px-4 py-2 bg-indigo-50 text-indigo-700 rounded-lg hover:bg-indigo-100 transition">
                ❓ Manage FAQ & Chatbot
              </Link>
            </div>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-bold text-gray-900 mb-4">{t('admin.recentActivity')}</h2>
            <p className="text-gray-600">{t('admin.noRecentActivity')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
